// ============================================================
// Inbox Module — Router (index.tsx)
// Lazy-loads sub-routes for the inbox module.
// ============================================================
import React, { lazy, Suspense } from 'react';
import { Routes, Route } from 'react-router-dom';

const NammaSchoolNeeds = lazy(() => import('./namma-school/NammaSchoolNeeds'));
const NammaSchoolPavilion = lazy(
  () => import('./namma-school/NammaSchoolPavilion')
);

const InboxModule: React.FC = () => {
  return (
    <Suspense fallback={<div className="text-center p-5">Loading...</div>}>
      <Routes>
        <Route
          path="namma-school-namma-ooru-palli-needs"
          element={<NammaSchoolNeeds />}
        />
        <Route
          path="namma-school-namma-ooru-palli-pavilion"
          element={<NammaSchoolPavilion />}
        />
      </Routes>
    </Suspense>
  );
};

export default InboxModule;
